export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Direccion',
	plural_model_name_spanish: 'Direcciones',
	create_model_name_spanish: 'Nueva',
	text_delete: 'la',
}